<template>
  <ButtonGroup :primary-button-text="tr('javascript.TX_SAVE')"
               primary-button-icon-name="floppy-disk"
               :hide-primary-button="hideSaveButton"
               :primary-button-disabled="disableSaveButton"
               :size="size"
               @primary-button-click="$emit('save')"
               @secondary-button-click="$emit('cancel')">
  </ButtonGroup>
</template>

<script>
  import { translator } from '~/zf/frontend/common/mixins';
  import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';
  import ButtonGroup from './ButtonGroup.vue';

  export default {
    name: 'SaveModalButtonGroup',
    compatConfig: {
      MODE: 3,
    },
    components: {
      ButtonGroup,
    },
    mixins: [translator],
    props: {
      hideSaveButton: {
        type: Boolean,
        default: false,
      },
      disableSaveButton: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: BootstrapVariant.MEDIUM,
      },
    },
    emits: ['save', 'cancel'],
  };
</script>
